import { createStore, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
// import storage from 'redux-persist/lib/storage';
import storageSession from 'redux-persist/lib/storage/session'
import thunk from 'redux-thunk';

import rootReducer from './store/rootReducer';

const persistConfig =
{
	key: 'root',
	storage: storageSession, //storage,
	whitelist:
	[
		'assetCountReducer',
		'assetConditionInfoReducer',
		'assetDetailsReducer',
		'assetGraphCurrentDataReducer',
		// 'assetGraphHistoricalDataReducer',
		'assetListReducer',
		'centerDateTimeListReducer',
		'fetchFaultEnumReducer',
		'metricListReducer',
		'plotlyGraphAndTableJsonReducer',
		'sensorListReducer',
		'sensorUnresponsiveReasonListReducer',

		'customerListReducer',

		// 'assetFeedListReducer',
		// 'feedListReducer',

		'loginDataReducer',

		'ticketDetailsReducer',

		'userListReducer',
		'userDetailsReducer',

		'appCommonReducer'
	],
	timeout : null
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(persistedReducer, applyMiddleware(thunk));
const persistor = persistStore(store);

export { store, persistor };
